import { Component, inject } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { DataService, feinbodenformFilter, hauptbodenformFilter } from 'src/app/data.service';
import { bohrpunktNummerLabel, istPunktartDrehbar, istPunktartMitKalkSpiegeltiefe, istPunktartMitNummer, trackByIndex, punktartDisplayLabel, punktartNummerFromLabel } from 'src/app/data-model';
import { filzVersatz, kurzprotokollTiefenHinweis } from '../../filz-tiefen';
import { BodenformNachschlagenService } from '../../help/bodenform-nachschlagen.service';
import { MOOR_FBF_REGEX, MOOR_FBF_REGEX_MELDUNG, MOOR_HBFS, hbfAusMoorFbf, moorFbfVorschlaegeFuer } from 'src/app/bohrpunkte/moor-bodenform';

@Component({
    standalone: false,
    selector: 'bp-kurzprotokoll',
    templateUrl: './kurzprotokoll.component.html',
    styleUrls: ['./hl-area.component.css'],

})
export class KurzprotokollComponent extends HlAreaComponent {
  ds: DataService = inject(DataService);
  /** Katalog- und Listenknopf an den Bodenform-Feldern. */
  protected readonly nachschlagen = inject(BodenformNachschlagenService);

	istPunktartMitNummer = istPunktartMitNummer;
	istPunktartDrehbar = istPunktartDrehbar;
	istPunktartMitKalkSpiegeltiefe = istPunktartMitKalkSpiegeltiefe;

	/** Unter Kalk- und Spiegeltiefe: ab wo gemessen wird, bei Filz mit dem Hinweis auf die Auflage. */
	tiefenHinweis(): string {
		return kurzprotokollTiefenHinweis(this.data);
	}

	/** Bei einem Filz die Auflage in cm: Die Spiegeltiefe zählt dann ab Oberkante Ol (flur-tiefe.ts). */
	filzVersatz(): number {
		return filzVersatz(this.data);
	}
	trackByIndex = trackByIndex;
	bohrpunktNummerLabel = bohrpunktNummerLabel;
	hauptbodenformFilter = hauptbodenformFilter;
	feinbodenformFilter = feinbodenformFilter;
	moorFBFRegex = MOOR_FBF_REGEX;
	moorFBFRegexMessage = MOOR_FBF_REGEX_MELDUNG;
	moorHBFSuggestions = [...MOOR_HBFS];
	moorFBFSuggestionsFor = moorFbfVorschlaegeFuer;
	/**
	 * Moor-Feinbodenformen stehen in keiner Liste, aus der sich die Hauptbodenform
	 * ablesen liesse — sie ergibt sich aus dem Wert selbst (moor-bodenform.ts).
	 */
	hbfAusMoorFbf = hbfAusMoorFbf;

  onNummerChanged(data: { previous: string, current: string }) {
    this.ds.nummerChanged.emit({ id: this.data._id, num: data.current });
  }

  /** Pfeilrichtung eines drehbaren Symbols geändert: setzen und sofort speichern. */
  async onRotationChanged(deg: number): Promise<void> {
    this.data.rotation = deg;
    await this.ds.saveDocument(this.data);
  }

	punktartFilter() {
		return () => true;
	}

	/**
	 * Punktart-Typeahead: zeigt/sucht das Label "Beschreibung (Nummer)" (Single
	 * Source aus der Punktarten-Liste), speichert aber den `type` (reine Nummer) —
	 * analog AufnahmeComponent. Direkte Bindung an `data.type` (rohe Nummer) wuerde
	 * gegen die Label-Liste fehlschlagen ("Wert nicht in der Liste"). Unbekanntes
	 * laesst den type unveraendert (Validierung markiert es als Warnung).
	 */
	get punktartModel(): string {
		return punktartDisplayLabel(this.data?.type);
	}
	set punktartModel(label: string) {
		const nummer = punktartNummerFromLabel(label);
		if (nummer) this.data.type = nummer;
	}

	/**
	 * Punktart ueber den visuellen Picker gewaehlt: rohe Nummer setzen und die
	 * Aenderung als "dirty" melden (der Picker ist kein wd-*-Control und meldet
	 * die Aenderung daher selbst — analog AufnahmeComponent.generateNummer). So
	 * erscheint der Speichern-Knopf wie bei den uebrigen Feldern.
	 */
	onPunktartPicked(type: string): void {
		this.data.type = type;
		this.vs.dirty.next(true);
	}


  addFeinbodenform() {
    this.data.header.bodenform.bf.push({ trenner: '/', hbf: '', fbf: ''});
  }

  removeFeinbodenform() {
    this.data.header.bodenform.bf.pop();
  }

  canAddFeinbodenform() {
    const bf = this.data.header.bodenform.bf;
    const l = bf.length;
    return l > 0 && l < 3 && (bf[l-1].hbf || bf[l-1].fbf);
  }
}
